import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { PageNotFoundComponent } from "./common/page-not-found/page-not-found.component";
import { ThankyouComponent } from './pages/thankyou/thankyou.component';
import { EnginneringComponent } from './pages/enginnering/enginnering.component';
import { EducationComponent } from './pages/education/education.component';
import { ManagementComponent } from './pages/management/management.component'; 
// import { AboutUsComponent } from './about-us/about-us.component';
//import { ContactUsComponent } from './pages/contact-us/contact-us.component';
//import { GalleryComponent } from './pages/gallery/gallery.component';
//import { BlogsComponent } from './pages/blogs/blogs.component';
//import { BlogDetailComponent } from './pages/blog-detail/blog-detail.component';
//import { TermsComponent } from './pages/terms/terms.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'thankyou', component: ThankyouComponent },
  { path: 'engineering_admission', component: EnginneringComponent },
  { path: 'education_admission', component: EducationComponent },
  { path: 'management_admission', component: ManagementComponent },
  { path: '**', component: PageNotFoundComponent },
 
  // { path: 'gallery', component: GalleryComponent },
  // { path: 'blogs', component: BlogsComponent },
  // { path: 'blog-detail/:id', component: BlogDetailComponent },
  // { path: 'blog-detail', component: BlogDetailComponent },
  // { path: 'terms', component: TermsComponent },
  // otherwise redirect to page not found
];


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(
      routes,
      // { enableTracing: true } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule { }
